import React from "react";

type SectionFrameProps = {
  id?: string;
  className: string;
  label?: string;
  title?: string;
  subtitle?: string;
  children: React.ReactNode;
};

export default function SectionFrame({
  id,
  className,
  label,
  title,
  subtitle,
  children,
}: SectionFrameProps) {
  return (
    <section id={id} className={className}>
      {(label || title || subtitle) && (
        <>
          {label ? <div className="section-label">{label}</div> : null}
          {title ? <h2 className="section-title">{title}</h2> : null}
          {subtitle ? <p className="section-subtitle">{subtitle}</p> : null}
        </>
      )}
      {children}
    </section>
  );
}
